import { render, staticRenderFns } from "./app-modal-form.vue?vue&type=template&id=54acf358"
import script from "./app-modal-form.vue?vue&type=script&lang=ts"
export * from "./app-modal-form.vue?vue&type=script&lang=ts"
import style0 from "./app-modal-form.vue?vue&type=style&index=0&id=54acf358&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54acf358')) {
      api.createRecord('54acf358', component.options)
    } else {
      api.reload('54acf358', component.options)
    }
    module.hot.accept("./app-modal-form.vue?vue&type=template&id=54acf358", function () {
      api.rerender('54acf358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-modal/app-modal-form.vue"
export default component.exports